export default __webpack_public_path__ + "static/media/inventries.3f3e7c3a.svg";